import EventBase from './EventBase'
import EventID from './EventID'

/**
 * 103 - 自动播放剧情
 */
class EventAutoPlay extends EventBase {
  private syncDescription() {
    this.Description = this.AutoPlay ? '[开]' : '[关]'
  }

  /**
   * 自动播放剧情的构造函数
   */
  constructor() {
    super()
    this.Parameter = ['0', '']
    this.syncDescription()
  }

  /**
   * 事件ID
   */
  public Code: EventID = EventID.AutoPlay

  // #region 事件相关参数都在这里
  /**
   * 是否自动播放
   */
  get AutoPlay() {
    return this.Parameter && this.Parameter[0] === '1' ? true : false
  }

  set AutoPlay(val) {
    this.Parameter![0] = val ? '1' : '0'
    this.syncDescription()
  }

  get Description() {
    return this.Parameter?.[1] ?? ''
  }

  set Description(val) {
    this.Parameter![1] = val
  }
  // #endregion

  /**
   * 获取显示信息
   * @returns
   */
}

export default EventAutoPlay
